export default __webpack_public_path__ + "static/media/reloj.c4f62aeb.svg";